import ModalViewFile from "./ModalViewFile";

export default ModalViewFile;
